module.exports = {"localPath":"http://localhost:3333","herokuPath":"https://labs-resume-maker.herokuapp.com","altHerokuPath":"https://rez-me.herokuapp.com","basePath":"herokuPath"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 22
// module chunks = 0